import { create } from "zustand"
import { createJSONStorage, devtools, persist } from "zustand/middleware"
import { PeriodTypeView } from "@/types"
import { DirectCostScenario } from "../api/types"

type Store = {
  view: PeriodTypeView
  setView: (view: PeriodTypeView) => void
  scenario: DirectCostScenario
  setScenario: (scenario: DirectCostScenario) => void
}

export const useCogsStore = create<Store>()(
  devtools(
    persist(
      (set) => ({
        view: `monthly`,
        setView: (view) => set({ view }),
        scenario: 1,
        setScenario: (scenario: DirectCostScenario) => set({ scenario }),
      }),
      {
        name: `cogs_store`,
        storage: createJSONStorage(() => sessionStorage),
      }
    )
  )
)
